import { createSelector } from '@reduxjs/toolkit';
import { chain } from 'lodash';
import { useAPI } from '../../state';
import { TaskStatus, TaskType } from '../hooks';
var GET_USER_TASK_API = '/api/report/process';
var UPDATE_IS_NOTIFIED_API = '/api/report/process/{id}';
var selectToastMessages = function (messages) { return messages; };
var isInProgressStatus = function (status) { return status === TaskStatus.Processing || status === TaskStatus.Created; };
var selectSimulationInProgress = createSelector(selectToastMessages, function (messages) {
    return chain(messages)
        .filter(function (_a) {
        var status = _a.status, taskType = _a.taskType;
        return isInProgressStatus(status) && taskType === TaskType.MultiskillSimulation;
    })
        .reverse()
        .groupBy('details.basePlanId')
        .value();
});
var selectActualExportInProgress = createSelector(selectToastMessages, function (messages) {
    return chain(messages)
        .filter(function (_a) {
        var status = _a.status, taskType = _a.taskType;
        return isInProgressStatus(status) && taskType === TaskType.ActualReportExport;
    })
        .reverse()
        .groupBy('details.basePlanId')
        .value();
});
var selectCompletedSimulations = createSelector(selectToastMessages, function (messages) {
    return chain(messages)
        .filter(function (_a) {
        var status = _a.status, taskType = _a.taskType;
        return !isInProgressStatus(status) && taskType === TaskType.MultiskillSimulation;
    })
        .keyBy('details.basePlanId')
        .value();
});
var selectCompletedExports = createSelector(selectToastMessages, function (messages) {
    return chain(messages)
        .filter(function (_a) {
        var status = _a.status, taskType = _a.taskType;
        return !isInProgressStatus(status) && taskType === TaskType.ActualReportExport;
    })
        .keyBy('details.basePlanId')
        .value();
});
export var useToastMessagesAPI = function () {
    return useAPI(GET_USER_TASK_API);
};
export var useUpdateStatusAPI = function (id) {
    return useAPI(UPDATE_IS_NOTIFIED_API, { id: id }, 'PUT');
};
export var useSimulatingInProgress = function (basePlanId, taskType) {
    if (basePlanId === void 0) { basePlanId = ''; }
    if (taskType === void 0) { taskType = TaskType.MultiskillSimulation; }
    var data = useToastMessagesAPI()[0].data;
    if (taskType === TaskType.ActualReportExport) {
        return selectActualExportInProgress(data)[basePlanId];
    }
    return selectSimulationInProgress(data)[basePlanId];
};
export var useIsCompletedSimulation = function (basePlanId, taskType) {
    if (basePlanId === void 0) { basePlanId = ''; }
    if (taskType === void 0) { taskType = TaskType.MultiskillSimulation; }
    var data = useToastMessagesAPI()[0].data;
    if (taskType === TaskType.ActualReportExport) {
        return !!selectCompletedExports(data)[basePlanId];
    }
    return !!selectCompletedSimulations(data)[basePlanId];
};
